import { Injectable } from '@angular/core';
import { delay, of, type Observable } from 'rxjs';

import type { EmailResolutionResponsesClient } from '../tokens/email-resolution-responses-client.token';
import type { EmailResolutionResponseItem } from '../../features/email-response/models/email-response.model';

const MOCK_EMAIL_RESOLUTION_RESPONSES: EmailResolutionResponseItem[] = [
  { id: 1, description: 'ADC Discrepancy' },
  { id: 2, description: 'ADC Error' },
  { id: 3, description: 'Charting Error' },
  { id: 4, description: 'Dropped/Spilled CS Med' },
  { id: 5, description: 'Duplicate Waste Transaction' },
  { id: 6, description: 'Med Removed on Wrong Patient' },
  { id: 7, description: 'Med Waste Documented = not Wasted Throught ADC/View' },
  { id: 8, description: 'Unaccounted' },
  { id: 9, description: 'Waste Entry Error' },
  { id: 10, description: 'Waste Med in Sharps Bin/Sink/Trash' },
  { id: 11, description: 'Wasted on Wrong ADC Med Entry' },
  { id: 12, description: 'Wasted on Wrong Patient' },
  { id: 13, description: 'Wrong Med Removed from ADC' },
  { id: 14, description: 'Return Not Waste' },
];

@Injectable({ providedIn: 'root' })
export class EmailResolutionResponsesMockService implements EmailResolutionResponsesClient {
  getEmailResolutionResponses(): Observable<EmailResolutionResponseItem[]> {
    return of([...MOCK_EMAIL_RESOLUTION_RESPONSES]).pipe(delay(300));
  }
}
